import React, { useEffect } from "react";
import LayersControl from '../../components/3d-map/layers-control/layers-control';
import PanelButton from '../../components/3d-map/panel-button/panel-button';
import layerPickerImage from '../../images/layers.svg'
import infoImage from '../../images/info.svg'
import homeImage from '../../images/home.svg'
import styles from './map.module.css'
import FeatureDescription from "../../components/3d-map/feature-description/feature-description";
import ViewerInfoPanel from '../../components/3d-map/info-panel/info-panel'
import ZoomLevel from "../../components/3d-map/zoom-level/zoom-level";
import { useDispatch, useSelector } from "react-redux";
import { info, layersPanel, selectPanel } from "../../services/reducers/map";
import { focusOnHome, initializeCesium, getLayersDescription } from "../../services/actions/map";


export default function Map() {
  const selectedPanel = useSelector(state => state.map.selectedPanel);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeCesium());
    dispatch(getLayersDescription());
  }, [dispatch]);
  return (
    <div className={styles.content}>
      <div id="cesiumContainer" className={styles.cesiumContainer}></div>
      <div className={styles.panelButtons}>
        <PanelButton
          imageSrc={infoImage}
          onClickFunction={() => {dispatch(selectPanel(info))}}
          className={selectedPanel === info ? styles.panelButtonSelected : null}
        />
        <PanelButton
          imageSrc={homeImage}
          onClickFunction={() => dispatch(focusOnHome())}
        />
        <PanelButton
          imageSrc={layerPickerImage}
          onClickFunction={() => {dispatch(selectPanel(layersPanel))}}
          className={selectedPanel === layersPanel ? styles.panelButtonSelected : null}
        />
      </div>
      <FeatureDescription/>
      <LayersControl/>
      <ViewerInfoPanel/>
      <ZoomLevel/>
    </div>
  );
}

